import React from "react";
import { Section } from "../Section";
import { DOCTOR_URL } from "../../data/landing";
export function DoctorMessageSection() {
  return <Section tone="cream" cta="I want access to the Clinical Pathway™" data-id="element-104" data-mp="2qpm6p834kc42">
      <div className="grid items-start gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] md:gap-12" data-id="element-105" data-mp="2mm6dklq9ktw4">
        <figure className="md:sticky md:top-8" data-id="element-106" data-mp="2hn38j1aaano5">
          <img src={DOCTOR_URL} alt="Dr. Michael Carter" className="aspect-[4/5] w-full rounded-3xl object-cover object-top shadow-xl" data-id="element-107" data-mp="2hqh6lxbx0aps" />
          <figcaption className="mt-3 text-center text-sm font-semibold text-inkSoft" data-id="element-108" data-mp="27w8j5o1qr7yh">
            Dr. Michael Carter · Creator of the Clinical Pathway™
          </figcaption>
        </figure>

        <div data-id="element-109" data-mp="1yzhong2u8160">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-rose" data-id="element-110" data-mp="1yvtv4gxe7era">A message from Dr. Michael Carter</p>
          <h2 className="mt-3 font-serif text-[30px] font-bold leading-tight text-ink md:text-4xl" data-id="element-111" data-mp="1ozquxgm3pq6z">
            “I didn't create another breast augmentation course.”
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-inkSoft" data-id="element-112" data-mp="3ie57j1wdownp">
            <p data-id="element-113" data-mp="3n7zqg345t7lq">I've spent years studying, reviewing and discussing surgical cases. And over time, I noticed something that kept coming up.</p>
            <p data-id="element-114" data-mp="3edv1jp8l668u">
              A physician can know a tremendous amount about breast augmentation and still feel uncertain about how to
              organize the information when faced with a new case.
            </p>
            <p className="font-serif text-xl font-bold text-ink" data-id="element-115" data-mp="9z50hvse4osh">
              Knowing information is one skill. Knowing how to systematically review a case is another.
            </p>
            <p data-id="element-116" data-mp="yyo6d8fhuuw">
              You can watch another lecture. Read another paper. Attend another conference. But eventually, you have to
              sit down with the case itself. That's where I wanted to focus.
            </p>
            <p data-id="element-117" data-mp="2lqie7culpueh">I wanted to create a process that would make you stop for a moment and ask:</p>
            <ul className="space-y-2 rounded-2xl bg-white p-5 font-medium text-ink" data-id="element-118" data-mp="21mb50l4as4c6">
              {["What do I actually see?", "What information do I have?", "What am I missing?", "What questions does this case raise?", "What deserves closer review?", "What did I learn from this case?"].map(q => <li key={q} className="flex gap-2.5" data-id="element-119" data-mp="1iyejzm6g2iwh">
                  <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-rose" aria-hidden="true" data-id="element-120" data-mp="1dxigh9q08yrl" />
                  {q}
                </li>)}
            </ul>
            <p data-id="element-121" data-mp="14xbxx9fg98lk">
              Open the case. Take approximately 15 minutes. Don't look for the answer immediately.{" "}
              <strong className="text-ink" data-id="element-122" data-mp="34apqmz0ag2xq">First, tell me what you see.</strong> Then organize your observations.
              Identify what you still need to clarify. Prioritize what deserves additional review. Compare your
              reasoning with the educational discussion. And finally, write down what you learned.
            </p>
            <p className="text-[15px]" data-id="element-123" data-mp="3bs4dxalse3h4">
              I didn't create this system to replace formal surgical training, mentorship, current clinical guidance or
              professional judgment. I created it as a structured educational framework for practicing case analysis.
            </p>
            <p className="font-semibold text-ink" data-id="element-124" data-mp="2nxkx9rmtza1h">
              If you're serious about becoming more structured in the way you review educational breast augmentation
              cases, I built this for you.
            </p>
            <p className="font-serif text-xl font-bold italic text-ink" data-id="element-125" data-mp="2xwk73djc1bq2">— Dr. Michael Carter</p>
          </div>
        </div>
      </div>
    </Section>;
}